// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxlargeOnConfined-superElipse-e024d6a0","strokeWidth":"super-ellipse-skins-xxxlargeOnConfined-strokeWidth-46bc48ec"};